export enum Role {
  HH = 'ROLE_HH',
  SHG = 'ROLE_SHG',
  HML = 'ROLE_HML',
  ADMIN = 'ROLE_ADMIN'
}

export type InvitableRoles = 'HML' | 'SHG' | 'ANY';